<template>
  <div class="claim-item">
    <YorkbbsImage
      width="160px"
      height="105px"
      borderRadius="4px"
      animation
      :src="coverImage"
      :link="detailURL"
      target="_blank"
    />

    <div class="claim-center">
      <!-- 标题 -->
      <a target="_blank" :href="detailURL" class="claim-title">
        <span class="shop-name" v-if="shopCnName">{{ shopCnName }}</span>
        <span class="divider" v-if="shopCnName"></span>
        <span class="title">{{ title }}</span>
      </a>

      <!-- 电话 -->
      <div class="claim-tel" v-if="contactNumber">电话：{{ contactNumber | phoneFormat }}</div>

      <!-- 地址 -->
      <div class="claim-address" v-if="address">地址：{{ address }}</div>
    </div>

    <div class="claim-right">
      <div v-if="claim === 0 && claimStatus === undefined">
        <div class="claim-status">这是你的店？</div>
        <el-button class="claim-button" type="primary" plain size="mini" @click="claimVisible = true"
          >立即认领</el-button
        >
      </div>
      <div v-if="claim === 0 && claimStatus === 0">
        <div class="claim-status">审核中</div>
      </div>
      <div v-if="claim === 1">
        <div class="claim-status">已认领</div>
      </div>
    </div>
    <!-- 黄页认领 -->
    <YorkbbsClaimDialog :id="data.id" :visible.sync="claimVisible" v-if="claimVisible"></YorkbbsClaimDialog>
    <!-- 黄页详情 -->
    <YorkbbsInfoDialog :data="data" :visible.sync="detailVisible" v-if="claimVisible"></YorkbbsInfoDialog>
  </div>
</template>
<script>
import YorkbbsClaimDialog from '../components/dialog-claim.vue';
import YorkbbsInfoDialog from './dialog-info.vue';
export default {
  name: 'ItemClaim',
  components: { YorkbbsClaimDialog, YorkbbsInfoDialog },
  props: {
    // 黄页详情
    data: Object,
  },
  data() {
    return {
      // 认领对话框显示状态
      claimVisible: false,
      // 黄页详情对话框显示状态
      detailVisible: false,
    };
  },
  computed: {
    images() {
      return this.data.image || [];
    },
    coverImage() {
      return this.images[0];
    },
    title() {
      return this.data.title;
    },
    contactNumber() {
      return this.data.property.contactNumber;
    },
    address() {
      return this.data.property.address;
    },
    shopCnName() {
      return this.data.property.shopCnName;
    },
    claim() {
      return this.data.property.claim;
    },
    claimStatus() {
      return this.data.property.claimStatus;
    },
    user() {
      return this.data.user;
    },
    isMe() {
      return this.user === this.$store.getters.user.id;
    },
    detailURL() {
      return `/detail/${this.data.property.topics[0].englishName}/${this.data.id}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.claim-item {
  padding: 18px 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  &:not(:first-child) {
    margin-top: 30px;
  }
}

.claim-center {
  flex: 1;
  margin: 0 20px;
}

.claim-right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.claim-title {
  line-height: 26px;
  display: block;

  .shop-name {
    font-size: 18px;
    vertical-align: middle;
    &:hover {
      color: var(--primary-color);
    }
  }

  .divider {
    display: inline-block;
    height: 14px;
    border-left: 1px solid var(--text-color-3);
    vertical-align: middle;
    margin: 0 5px;
  }

  .title {
    font-size: 18px;
    color: var(--text-color-3);
    vertical-align: middle;
    &:hover {
      color: var(--primary-color);
    }
  }
}

.claim-tel {
  padding-top: 10px;
  color: var(--text-color-9);
}

.claim-address {
  padding-top: 10px;
  color: var(--text-color-9);
}

.claim-status {
  font-size: 14px;
  line-height: 22px;
  color: var(--text-color-3);
}

.claim-button {
  &.el-button--text {
    color: var(--text-color-9);
  }
  margin-top: 6px;
}
</style>
